import { FileStatusType } from "@fronterahealth/frontera-ui-components";

export const isFileUploaded = (fileStatus: FileStatusType) => {
  return [
    "parsing",
    "parsing-failed",
    "ai-generating",
    "ai-generation-failed",
    "done",
    "classifying",
    "classifying-error",
    "classifying-success",
  ].includes(fileStatus);
};
